/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable indent */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import {
  Grid,
  InputLabel,
  Button,
  TextField,
} from '@material-ui/core';
import { validateUrl } from 'utils/validateUrl';
import useStyles from './styles';
import { getFriendlyErrorMessage } from '../../../utils/errorHelper';
import { Toast } from '../../../components/Toast';

interface IImportUrlsFormProps {
  query_f: (variables: any) => Promise<any>;
}

const ImportUrlsForm: React.FC<IImportUrlsFormProps> = ({ query_f }) => {
  const classes = useStyles();

  const [urls, setUrls] = useState<string>('');

  const saveContent = () => {
    const urlsPerLine = urls
      .split('\n')
      .filter((item: string) => item);

    for (const url of urlsPerLine) {
      if (!validateUrl(url)) {
        Toast(`There is an invalide URL: ${url}`, 'error');
        return;
      }
    }

    const joinedValidatedUrls = urlsPerLine.join('\n');

    const variables = {
      urls: joinedValidatedUrls,
    };

    query_f({
      variables,
    }).then(
      () => {
        Toast('Action executed with success!');
      },
      (error) => {
        Toast(getFriendlyErrorMessage(error), 'error');
      },
    );
  };

  return (
    <form id="myForm">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <InputLabel className={classes.inputLabel}>URLs (One per line)</InputLabel>
          <TextField
            id="urls"
            multiline
            rows={8}
            onChange={({ target }) => setUrls(target.value)}
            value={urls}
            color="primary"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={() => saveContent()}
            fullWidth
            variant="contained"
            className={classes.btnSave}
            disabled={urls.length === 0}
          >
            Import
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ImportUrlsForm;
